import { Column } from "../../../../core/components/Column";
import { Row } from "../../../../core/components/Row";
import { TextComponent } from "../../../../core/components/TextComponent";

export const TitleList = ({ icon, text, subtext }: { icon: JSX.Element; text: string; subtext?: string }) => {
	return (
		<Row crossAxisAlignment="center" className="gap-4">
			{icon}
			<Column className="gap-1.5">
				<TextComponent
					variant="h5"
					className="font-semibold"
				>
					{text}
				</TextComponent>
				<TextComponent
					variant="h6"
					className="text-graySecondary"
				>
					{subtext}
				</TextComponent>
			</Column>
		</Row>
	);
};
